import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';

@Injectable()
export class ApiAuthenticationInterceptor implements HttpInterceptor {
    constructor(private readonly injector: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.indexOf(environment.AWS_API_URL) !== -1 || req.url.indexOf(environment.AWS_API_ORDER_URL) !== -1) {
            let authSrv = this.injector.get(AuthService);
            if (authSrv.lastUsedIdToken != null) {
                const modifiedReq = req.clone({
                    headers: req.headers.set('Authorization', authSrv.lastUsedIdToken),
                });
                return next.handle(modifiedReq);
            } else {
                return next.handle(req);
            }
        } else {
            return next.handle(req);
        }
    }
}
